<template>
  <div>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
  </div>
</template>

<script>
import formjson from './Model/Formjson.Log'
import tablejson from './Model/Tablejson.Log'
import formTableMixin from '@manage/mixins/formTableMixin'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      queryApi: this.$api.system.log_list,
      row: {}
    }
  },
  methods: {
    formSearch(data) {
      this.search(data, null, this.queryApi)
    }
  }
}
</script>
<style lang="less"></style>
